import React from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { Details } from '@application/Interfaces/Features/SubTitleDescriptionCTAImage/Details/Details'
import { SubTitleDescriptionCTAImageItemType, ThemeModeType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

export const SubTitleDescriptionCTAImageItem = ({
    item,
    mode,
}: {
    item: SubTitleDescriptionCTAImageItemType
    mode: ThemeModeType
}): JSX.Element => {
    return (
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            flexDirection={{
                xs: 'row',
                md: item.alignment === 'left' ? 'row' : 'row-reverse',
            }}
        >
            <Grid item xs={12} md={6} xsSpacingBottom={6} align="center">
                {item?.image && <Image image={item.image} imageAnimation={item.imageAnimation} />}
            </Grid>
            <Grid item xs={12} md={1}></Grid>
            <Grid item xs={12} md={4}>
                <Details
                    title={item.title}
                    description={item.description}
                    viewMore={item.viewMore}
                    viewMoreLinkLabel={item.viewMoreLinkLabel}
                    mode={mode}
                />
            </Grid>
            <Grid item xs={12} md={1}></Grid>
        </Grid>
    )
}
